import { NativeStackHeaderProps } from '@react-navigation/native-stack';
import { FC } from 'react';
import { StandardNavigation } from '~/components/topNavigation';
import { EmitterEvent } from '~/types/emitter';
import Emitter from '~/utils/emitter';

export interface CalendarTodayTopNavigationProps extends NativeStackHeaderProps {
    onBackPress?: () => void;
}

export const CalendarTodayTopNavigation: FC<CalendarTodayTopNavigationProps> = ({ onBackPress }) => {
    const handleRightPress = () => {
        Emitter.emit(EmitterEvent.scrollToDate, null);
    };

    return (
        <StandardNavigation
            customLeftIconName="close"
            shouldRenderRightButton
            variant="rightButton"
            rightButtonText="Dzisiaj"
            onRightPress={handleRightPress}
            onBackPress={onBackPress}
        />
    );
};
